import { useCallback } from 'react';
import { useAppBridge } from '@shopify/app-bridge-react';

/**
 * Returns an authenticated fetch function that automatically attaches
 * the Shopify session token (JWT) to the Authorization header.
 *
 * Uses App Bridge v4's shopify.idToken() — the token is refreshed automatically.
 *
 * Usage:
 *   const authFetch = useAuthFetch();
 *   const res = await authFetch('/api/status');
 *   const data = await res.json();
 */
export function useAuthFetch() {
  const shopify = useAppBridge();

  return useCallback(
    async function authFetch(url, options = {}) {
      const token = shopify ? await shopify.idToken() : null;
      return fetch(url, {
        ...options,
        headers: {
          'Content-Type': 'application/json',
          ...options.headers,
          Authorization: `Bearer ${token}`,
        },
      });
    },
    [shopify]
  );
}
